<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import PrintOptions from "@/components/modals/print-options.vue";
import DatePicker from "vue2-datepicker";
import ResourceUpdate from "@/router/views/office/office-widgets/planning-resource-item.vue";
import OpcrLogs from "@/router/views/office/office-widgets/opcr-logs.vue";

export default {
    page: {
        title: "Planning API Resources",
    },
    components: {
        Layout,
        PageHeader,
        PrintOptions,
        DatePicker,
        ResourceUpdate,
        OpcrLogs
    },
    data() {
        return {
            title: "Planning API & Resources",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Planning API & Resources",
                    active: true,
                },
            ],
            filterDUs: "",
            campusTemplates: [],
            campusBusy: false,
            apiDates: {
                advertisement: null,
                submission: null,
                noticeOfAward: null,
                contractSigning: null,
            },
            modalTitle: '',
            selectedApi: null,
            returnForm: {
                id: 0,
                remarks: "",
            },
            selectedParent: null
        }
    },
    validations: {
        apiDates: {
            advertisement: { required },
            submission: { required },
            noticeOfAward: { required },
            contractSigning: { required },
        },
        returnForm: { remarks: { required } },
    },
    computed: {
        filteredDUs() {
            let data = this.campusTemplates;
            if (this.filterDUs.trim() != "" && this.filterDUs) {
                data = data.filter((item) => {
                    return item.deliveryUnit.name
                        .toUpperCase()
                        .includes(this.filterDUs.toUpperCase());
                });
            }
            let groupedData = [];
            let id = 1;
            var grouped = groupBy(data, "officeName");
            for (const y in grouped) {
                groupedData.push({
                    officeName: y,
                    id: id++,
                    deliveryUnits: grouped[y],
                });
            }
            return groupedData;
        },
    },
    async mounted() {
        this.pageLoader(true);
        await this.changeCycle(this.$store.state.data.cycle, true);
        this.pageLoader(false);
    },
    methods: {
        async changeCycle(cycle, first) {
            this.getCampusTemplates(this.$store.state.data.selectedCampus);
        },
        async getCampusTemplates(campus) {
            this.campusBusy = true;
            this.campusTemplates = [];
            await this.$store
                .dispatch("preplanningtarget/GetPrePlanningDUs", {
                    cycle: this.$store.state.data.cycle,
                    campusId: campus.id,
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map((x) => {
                        x.officeName = x.office.name;
                        x.rotateChevy = false;
                        x.opcrLoading = false;
                        x.rotateChevy = false;
                        x.opcrList = [];
                    });
                    this.campusTemplates = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            this.campusBusy = false;
        },
        async getOPCRByDU(y){
            y.opcrList = [];
            await this.$store
                .dispatch("preopcr/GetPostedPreOpcr", {deliveryUnitId: y.deliveryUnitId, cycle: this.$store.state.data.cycle})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.apiLoading = false;
                        item.apiList = [];
                        item.viewApis = false;
                    })
                    y.opcrList = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getApis(y){
            y.viewApis = !y.viewApis;
            if(y.viewApis && y.apiList.length == 0){
                y.apiLoading = true;
                await this.getApiList(y);
                y.apiLoading = false;
            }
        },
        async showOPCRs(y){
            y.rotateChevy = !y.rotateChevy;
            if(y.rotateChevy && y.opcrList.length == 0){
                y.opcrLoading = true;
                await this.getOPCRByDU(y);
                y.opcrLoading = false;
            }
        },
        async getApiList(y){
            y.apiList = [];
            await this.$store
                .dispatch("planningapi/GetPlanningApisByOPCR", y.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach(x => {
                        x.viewResource = false;
                        x.resourceList = [];
                        x.budgetData = [];
                        x.resourceLoading = false;
                    })
                    y.apiList = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            y.apiLoading = false;
        },
        async viewApiResource(y, parent){
            y.viewResource = !y.viewResource;
            y.resourceLoading = true;
            await this.getBudgetofApi(y, parent);
            await this.getResource(y);
        },
        async getResource(y){
            if(y.resourceList.length == 0 && y.viewResource){
                await this.$store
                    .dispatch("planningapiresource/GetPlanningApiResourcesByApi", y.id)
                    .then((res) => {
                        res.data.map(item => {
                            let budgetInfo = y.budgetData.find(
                                (x) => x.id == item.financeTemplateBudgetItemId
                            );
                            item.totalQuantity =
                            item.planningApiResourceDetails.reduce(
                                (pv, cv) => {
                                    return (
                                        parseFloat(pv) + parseFloat(cv.quantity)
                                    );
                                },
                                0
                            );
                            item.financeTemplateBudgetItem = {
                                fundSource: budgetInfo.fundSource,
                                fundClass: budgetInfo.fundClass,
                                accountGroup: budgetInfo.groupName,
                                accountId: budgetInfo.accountGroupId,
                            };
                        })
                        y.resourceList = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            y.resourceLoading = false;
        },  
        async getBudgetofApi(y, parent) {
            y.budgetData = [];
            await this.$store
                .dispatch("financeTemplate/getDeliveryUnitFunds", {deliveryUnitId: parent.deliveryUnitId, cycle: this.$store.state.data.cycle})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.forEach((item) => {
                        item.fundClass = item.fundClassification.classification;
                        item.fundSource = item.sourceName;
                        item.accountGroup = item.groupName;
                        item.filterKey = `${item.fundSource} ${item.accountGroup} ${item.fundClass}`;
                    });
                    y.budgetData = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        groupBudget(y){
            this.$refs['resource-update'].budgetData = cloneDeep(y.budgetData);
            var groupedFS = groupBy(y.data, "fundSource");
            var grouped = [];
            var id = 1;
            var FCID = 1;
            for (const key in groupedFS) {
                var sumBalance = 0;
                var sumAllocated = 0;
                var filterKey = "";
                groupedFS[key].forEach((a) => {
                    sumBalance += a.balance;
                    sumAllocated += a.amount;
                    filterKey += `${a.fundSource} ${a.accountGroup} ${a.fundClass}`;
                });
                var group = groupBy(groupedFS[key], "fundClass");
                var FC = [];
                for (const y in group) {
                    var filterY = "";
                    group[y].forEach((a) => {
                        filterY += `${a.fundSource} ${a.accountGroup} ${a.fundClass}`;
                    });
                    FC.push({
                        id: FCID++,
                        data: group[y],
                        key: y,
                        filterKey: filterY,
                    });
                }
                grouped.push({
                    id: id++,
                    fsName: key,
                    data: FC,
                    balance: sumBalance,
                    allocated: sumAllocated,
                    showData: false,
                    filterKey: filterKey,
                });
            }
            this.$refs['resource-update'].groupedBudget = grouped;
        },
        printAPP(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Preplanning/APP",
                routeVariables: [this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        updateDates(row){
            this.selectedApi = row;
            this.apiDates = {
                id: row.id,
                advertisement: row.advertisement === '0001-01-01T00:00:00' ? '' : new Date(row.advertisement),
                contractSigning: row.advertisement === '0001-01-01T00:00:00' ? '' : new Date(row.contractSigning),
                noticeOfAward: row.advertisement === '0001-01-01T00:00:00' ? '' : new Date(row.noticeOfAward),
                submission: row.advertisement === '0001-01-01T00:00:00' ? '' : new Date(row.submission),
            }
            this.$bvModal.show('update-dates-modal');
            this.modalTitle = 'Update Dates'
        },
        async onUpdateDates(){
            this.submitted = true;
            this.$v.apiDates.$touch();
            if(this.$v.apiDates.$invalid){
                return;
            }
            let data = cloneDeep(this.apiDates);
            data.advertisement = this.getDate(this.apiDates.advertisement);
            data.contractSigning = this.getDate(this.apiDates.contractSigning);
            data.noticeOfAward = this.getDate(this.apiDates.noticeOfAward);
            data.submission = this.getDate(this.apiDates.submission);
            await this.$store
                .dispatch("preplanningapi/PreplanningApiDates", data)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.error, "error");
                    }
                    this.selectedApi.advertisement = data.advertisement;
                    this.selectedApi.contractSigning = data.contractSigning;
                    this.selectedApi.noticeOfAward = data.noticeOfAward;
                    this.selectedApi.submission = data.submission;
                    this.$bvModal.hide('update-dates-modal');
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            this.submitted = false;
        },
        async updateResource(props, z){
            this.pageLoader(true);
            this.selectedApi = z;
            this.groupBudget(z);
            await this.$refs['resource-update'].getItemInfo(props, 'edit');
            this.pageLoader(false);
        },
        closeUpdateModal(data){
            let index = this.selectedApi.resourceList.findIndex(x => x.id == data.id);
            this.selectedApi.resourceList[index].totalQuantity = data.quantity;
            this.selectedApi.resourceList[index].totalWithInflation = data.amount;
        },
        successUpdateResource(data){
            let index = this.selectedApi.resourceList.findIndex(x => x.id == data.id);
            this.selectedApi.resourceList.splice(index, 1, data);
        },
        updateItemColumn(data){
            if(data.type === 'deduct'){
                this.selectedApi.resourceList.find((e) => e.id == data.id)[data.column] -= data.value;
            }else if(data.type === 'add'){
                this.selectedApi.resourceList.find((e) => e.id == data.id)[data.column] += data.value;
            }else{
                this.selectedApi.resourceList.find((e) => e.id == data.id)[data.column] = data.value;
            }
        },
        printPPMP(opcr, type){
            if(type == 2){
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/Planning/PPMP/Report",
                    routeVariables: [opcr.id],
                });
            }else{
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/PPMP/OPCR",
                    routeVariables: [opcr.id],
                });
            }
            this.$bvModal.show("print-options-modal");  
        },
        printIndicativePR(api){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/PR",
                routeVariables: [api.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        viewLogs(opcr){
            this.$bvModal.show('opcr-logs-modal');
            this.$refs.opcrLogs.modalTitle = `${opcr.title} Logs`
            this.$refs.opcrLogs.getData(opcr);
        },
        returnOPCR(opcr, parent){
            this.selectedParent = parent;
            this.returnForm = {
                id: opcr.id,
                remarks: "",
            }
            this.$bvModal.show("return-modal");
        },
        async returnOPCRSubmit() {
            this.submitted = true;
            this.$v.returnForm.$touch();
            if (this.$v.returnForm.$invalid) {
                return;
            }
            await this.$store
                .dispatch("preopcr/ReturnOPCR", this.returnForm)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.selectedParent.opcrList.findIndex(x => x.id == this.returnForm.id);
                    this.selectedParent.opcrList.splice(index, 1);
                    this.$bvModal.hide('return-modal');
                    this.showToast("Successfully returned", "success");
                })
                .catch((err) => {
                    console.log(err)
                    this.showToast("Something went wrong!", "error");
                });
        },
        async changeProc(row){
            let data = cloneDeep(row);
            data.isProcurable = !row.isProcurable;
            await this.$store
                .dispatch("planningapiresource/UpdatePlanningApiResource", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage,  "error");
                    }
                    row.isProcurable = data.isProcurable;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        }
    }
}

</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="getCampusTemplates">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="return-modal"
            title="Return Remarks"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="returnOPCRSubmit" class="needs-validation">
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label for="description">Remarks </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="returnForm.remarks"
                                placeholder="Enter Remarks..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.returnForm.remarks.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.returnForm.remarks.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.returnForm.remarks.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Return PPMP
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('return-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="update-dates-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form  @submit.prevent="onUpdateDates">
                <b-row class="mb-3">
                    <b-col sm="6">
                        <label for="advertisement">Advertisement </label>
                        <date-picker
                            v-model="apiDates.advertisement"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Advertisement..."
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.apiDates.advertisement.$error,
                            }"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.apiDates.advertisement.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.apiDates.advertisement.required"
                                >This value is required.</span
                            >
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <label for="submission">Submission </label>
                        <date-picker
                            v-model="apiDates.submission"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Submission..."
                            :class="{
                                'is-invalid':
                                    submitted && $v.apiDates.submission.$error,
                            }"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.apiDates.submission.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.apiDates.submission.required"
                                >This value is required.</span
                            >
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="6">
                        <label for="noticeOfAward">Notice of Award </label>
                        <date-picker
                            v-model="apiDates.noticeOfAward"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Notice of Award..."
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.apiDates.noticeOfAward.$error,
                            }"
                        ></date-picker>
                        <div
                            v-if="submitted && $v.apiDates.noticeOfAward.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.apiDates.noticeOfAward.required"
                                >This value is required.</span
                            >
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <label for="contractSigning">Contract Signing</label>
                        <date-picker
                            v-model="apiDates.contractSigning"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Notice of Award..."
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.apiDates.contractSigning.$error,
                            }"
                        ></date-picker>
                        <div
                            v-if="
                                submitted && $v.apiDates.contractSigning.$error
                            "
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.apiDates.contractSigning.required"
                                >This value is required.</span
                            >
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('update-dates-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <ResourceUpdate 
            ref="resource-update" 
            :fromProcurement="true"
            :budgetTransferModal="false"
            :updatableMixOption="false"
            :selectedApiId="selectedApi ? selectedApi.id : 0"
            @close-update="closeUpdateModal" 
            @update-item="successUpdateResource" 
            @specific-item-update="updateItemColumn"
        />
        <div
            class="
                d-flex
                align-items-center
                justify-content-between
            "
        >
            <div
                id="tickets-table_filter"
                class="dataTables_filter me-1"
            >
                <label
                    class="d-inline-flex align-items-center mb-0"
                >
                    <b-form-input
                        autocomplete="off"
                        v-model.lazy="filterDUs"
                        type="search"
                        placeholder="Search Delivery Unit..."
                        class="form-control"
                    ></b-form-input>
                </label>
            </div>
            <button type="button" class="btn btn-purple" @click="printAPP"><i class="bx bx-printer me-2"></i>Print Indicative APP</button>
        </div>
        <div class="my-3">
            <div v-if="campusBusy">
                <h3>Loading...</h3>
            </div>
            <div v-if="campusTemplates.length == 0 && !campusBusy">
                <h3>No data found...</h3>
            </div>
            <div
                v-if="
                    campusTemplates.length > 0 &&
                    filteredDUs.length == 0
                "
            >
                <h3>Search not found</h3>
            </div>
            <div v-if="campusTemplates.length > 0">
                <ul>
                    <li v-for="(a, aIndex) in filteredDUs" :key="a.id">
                        <span class="text-warning font-size-14">{{ a.officeName }}</span>
                        <ul>
                            <li
                                v-for="y in a.deliveryUnits"
                                :key="`${a.id}du${y.deliveryUnitId}`"
                                class="w-100 mb-2"
                            >
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <a
                                            href="javascript:void(0);"
                                            class="font-size-18 text-dark"
                                            @click="showOPCRs(y)"
                                            >{{ y.deliveryUnit.name }}
                                            <i
                                                class="bx bx-caret-right rotate"
                                                :class="{
                                                    'rotate-90': y.rotateChevy,
                                                }"
                                            ></i
                                        ></a>
                                    </div>
                                </div>
                                <b-collapse
                                    :visible="y.rotateChevy"
                                >  
                                    <div>
                                        <hr>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h5>List of OPCR(s)</h5>
                                            <a href="javascript:void(0);" class="font-size-20 text-white" @click="y.rotateChevy = false"><i class="bx bx-x"></i></a>
                                        </div>
                                        <div class="text-center" v-if="!y.opcrLoading && y.opcrList.length == 0">
                                            <h5>No OPCR(s) found</h5>
                                        </div>
                                        <div class="text-center" v-if="y.opcrLoading">
                                            <h5>Loading....</h5>
                                        </div>
                                        <template v-if="!y.opcrLoading && y.opcrList.length">
                                            <b-card 
                                                no-body 
                                                v-for="(opcr, oIndex) in y.opcrList" 
                                                :key="opcr.id" 
                                                :style="{zIndex: `${filteredDUs.length - aIndex}${y.opcrList.length - oIndex}`}">
                                                <b-card-header 
                                                    header-tag="header"
                                                    role="tab"
                                                    class="border"
                                                >
                                                    <div class="d-flex justify-content-between">
                                                        <div>
                                                            <h5 class="mb-0">{{opcr.title}}</h5>
                                                            <div>
                                                                <a href="javascript:void(0);" @click="getApis(opcr)">{{!opcr.viewApis ? 'View' : 'Hide'}} API(s)</a>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <button type="button" class="btn btn-warning btn-sm me-1" @click="returnOPCR(opcr, y)"><i class="bx bx-arrow-back"></i> Return PPMP</button>
                                                            <button type="button" class="btn btn-secondary btn-sm me-1" @click="viewLogs(opcr)"><i class="bx bx-receipt"></i> View Logs</button>
                                                            <b-dropdown
                                                            id="dropdown-dropleft"
                                                            right
                                                            variant="purple py-1 btn-sm"
                                                            toggle-class="text-decoration-none"
                                                            menu-class="dropdown-menu"
                                                            no-caret
                                                        >
                                                            <template #button-content>
                                                                <i class="bx bx-printer me-1"></i>
                                                                Print PPMP
                                                            </template>
                                                            <b-dropdown-item @click="printPPMP(opcr, 1)">V1</b-dropdown-item>
                                                            <b-dropdown-item @click="printPPMP(opcr, 2)">V2</b-dropdown-item>
                                                        </b-dropdown>
                                                        </div>
                                                    </div>
                                                </b-card-header>
                                                <b-collapse
                                                    :visible="opcr.viewApis"
                                                    :accordion="`detail-accordion-${opcr.id}`"
                                                    role="tabpanel"
                                                >
                                                    <b-card-body
                                                        class="border"
                                                    >
                                                        <div class="text-center" v-if="!opcr.apiLoading && opcr.apiList.length == 0">
                                                            <h5>No API(s) found</h5>
                                                        </div>
                                                        <div class="text-center" v-if="opcr.apiLoading">
                                                            <h5>Loading....</h5>
                                                        </div>
                                                        <div class="row" v-if="!opcr.apiLoading && opcr.apiList.length > 0">
                                                            <div class="col-md-12">
                                                                <table class="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                API Description
                                                                            </th>
                                                                            <th width="220px">
                                                                                Total Resources
                                                                            </th>
                                                                            <!-- <th width="90px" class="text-center">
                                                                                Action
                                                                            </th> -->
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <template v-for="w in opcr.apiList">
                                                                            <tr :key="`apiList-y${y.id}-w${w.id}`">
                                                                                <td>
                                                                                    <div>
                                                                                        <a href="javascript:void(0);" class="text-white" @click="viewApiResource(w, y)">{{w.name}}</a>
                                                                                    </div>
                                                                                    <small>
                                                                                        {{w.description}}
                                                                                    </small>
                                                                                    <div>
                                                                                        <small class="text-warning cursor-pointer me-1" @click="viewApiResource(w, y)">[View Resources]</small>
                                                                                        <!-- <small class="text-info cursor-pointer" @click="updateDates(w)">[APP Dates]</small> -->
                                                                                    </div>
                                                                                </td>
                                                                                <td class="text-right">
                                                                                    <span class="d-block mb-2">{{formatCurrency(w.total)}}</span>
                                                                                    <button type="button" class="btn btn-purple btn-sm mt-1" @click="printIndicativePR(w)"><i class="bx bx-printer"></i> Print Indicative PR</button>
                                                                                </td>
                                                                                <!-- <td class="align-middle">
                                                                                    <div class="d-flex justify-content-center">
                                                                                        <button type="button" @click="removeApi(w, y)" class="btn btn-clear px-1" title="Remove API"><i class="bx bx-trash text-danger font-size-18"></i></button>
                                                                                        <button type="button" @click="printPPMPAPI(w.id)" class="btn btn-clear px-1" title="Print PPMP"><i class="bx bx-printer text-purple font-size-18"></i></button>
                                                                                    </div>
                                                                                </td> -->
                                                                            </tr>
                                                                            <tr v-if="w.viewResource" :key="`apiListRrs-y${y.id}-w${w.id}`">
                                                                                <td colspan="3" v-if="!w.resourceLoading && w.resourceList.length == 0" class="broken-border text-center">
                                                                                    No data found
                                                                                </td>
                                                                                <td colspan="3" v-if="w.resourceLoading" class="broken-border text-center">
                                                                                    Loading...
                                                                                </td>
                                                                                <td colspan="3" v-if="!w.resourceLoading && w.resourceList.length > 0">
                                                                                    <div v-for="z in w.resourceList" :key="`resourceList-y${y.id}-w${w.id}-z${z.id}`" class="ms-3 mb-1 p-3 broken-border" >
                                                                                        <div class="d-flex align-items-center justify-content-between">
                                                                                            <div class="d-flex">
                                                                                                <div class="d-flex align-items-center">
                                                                                                    <div class="font-size-20 text-yellow">
                                                                                                        {{z.totalQuantity}} {{z.unit.unitName}}
                                                                                                    </div>
                                                                                                    <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <div>
                                                                                                        {{z.itemName}}
                                                                                                        <div>
                                                                                                            <small>{{z.description}}</small>
                                                                                                            <small>
                                                                                                                <span class="text-warning ms-1" v-if="z.isMixed">[Mixed]</span>
                                                                                                                <span class=" ms-1">
                                                                                                                    <span class="text-warning">[{{z.isProcurable ? 'Procurable' : 'Non-procurable'}}]</span>
                                                                                                                    <i 
                                                                                                                        class="mx-1 bx bx-transfer cursor-pointer text-green font-size-14" 
                                                                                                                        :title="`Change to ${z.isProcurable ? 'Non-Procurable' : 'Procurable'}`" 
                                                                                                                        @click="changeProc(z)"
                                                                                                                        v-if="!z.isMixed"
                                                                                                                    ></i>
                                                                                                                </span>
                                                                                                                
                                                                                                            </small>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="
                                                                                                            d-flex
                                                                                                            align-items-center
                                                                                                            mb-1
                                                                                                        "
                                                                                                    >
                                                                                                        <span
                                                                                                            class="
                                                                                                                badge
                                                                                                                bg-secondary
                                                                                                                text-white
                                                                                                                py-1
                                                                                                                px-2
                                                                                                                me-2
                                                                                                            "
                                                                                                            >{{
                                                                                                                z
                                                                                                                    .financeTemplateBudgetItem
                                                                                                                    .fundSource
                                                                                                            }}</span
                                                                                                        >
                                                                                                        <span
                                                                                                            class="
                                                                                                                badge
                                                                                                                bg-purple
                                                                                                                text-white
                                                                                                                py-1
                                                                                                                px-2
                                                                                                            "
                                                                                                            >{{
                                                                                                                z
                                                                                                                    .financeTemplateBudgetItem
                                                                                                                    .fundClass
                                                                                                            }}</span
                                                                                                        >
                                                                                                        <span
                                                                                                            class="
                                                                                                                badge
                                                                                                                bg-success
                                                                                                                text-white
                                                                                                                py-1
                                                                                                                px-2
                                                                                                                ms-2
                                                                                                            "
                                                                                                            >{{
                                                                                                                z
                                                                                                                    .financeTemplateBudgetItem
                                                                                                                    .accountGroup
                                                                                                            }}</span
                                                                                                        >
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="text-center">
                                                                                                <div class="font-size-20 text-yellow mb-0">
                                                                                                    {{formatCurrency(z.totalWithInflation)}}
                                                                                                </div>
                                                                                                <div>
                                                                                                    <small>
                                                                                                        ({{formatCurrency(z.unitCost)}})
                                                                                                    </small>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <a href="javascript:void(0);" class="d-flex align-items-center" @click="updateResource(z, w)"><i class="bx bx-edit"></i> Update this Resource</a>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                        </template>
                                    </div>
                                </b-collapse>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <print-options ref="printOpt"></print-options>
        <opcr-logs ref="opcrLogs"></opcr-logs>
    </Layout>
</template>